import * as React from "react";

import MuiMenuItem from "@mui/material/MenuItem";

const MenuItem = (props) => {
  return <MuiMenuItem disableRipple {...props} />;
};

export default MenuItem;
